export default __webpack_public_path__ + "clientapp/media/robot-07.a60002d3.png";